import { __decorate } from "tslib";
import axios from 'axios';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let DataVersions = class DataVersions extends VuexModule {
    constructor() {
        super(...arguments);
        this.dataVersions = [];
        this.dataVersionTimeout = null;
        this.hasInternet = true;
    }
    async fetchDataVersions() {
        let dataVersions = [];
        let dataVersionTimeout = new Date();
        let hasInternet = true;
        console.log('Fetching data versions from database');
        try {
            dataVersions = (await axios.get(`${process.env.VUE_APP_sw5eapiurl}/api/dataVersion`)).data;
            dataVersionTimeout.setDate(dataVersionTimeout.getDate() + 3);
        }
        catch (e) {
            hasInternet = false;
        }
        return { dataVersions, dataVersionTimeout, hasInternet };
    }
    async setNoInternet() {
        return { hasInternet: false };
    }
    async setInternet() {
        return { hasInternet: true };
    }
};
__decorate([
    MutationAction({ mutate: ['dataVersions', 'dataVersionTimeout', 'hasInternet'] })
], DataVersions.prototype, "fetchDataVersions", null);
__decorate([
    MutationAction({ mutate: ['hasInternet'] })
], DataVersions.prototype, "setNoInternet", null);
__decorate([
    MutationAction({ mutate: ['hasInternet'] })
], DataVersions.prototype, "setInternet", null);
DataVersions = __decorate([
    Module({ namespaced: true, name: 'dataVersions' })
], DataVersions);
export default DataVersions;
